document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.card-content-button');
  const popup = document.getElementById('videoPopup');
  const popupVideo = document.getElementById('popupVideo');
  const closeBtn = document.querySelector('.video-popup-close');
  const overlay = document.querySelector('.video-popup-overlay');

  // The script tag sits outside the section's `{% if data != blank %}` guard,
  // so on a journal page with no metaobject match none of this markup exists.
  if (!popup || !popupVideo || buttons.length === 0) return;

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const videoUrl = button.dataset.videoUrl;
      if (!videoUrl) return;

      popup.classList.add('active');
      popupVideo.src = videoUrl;
      popupVideo.play();

      document.body.style.overflow = 'hidden'; // optional
    });
  });

  const closePopup = () => {
    popup.classList.remove('active');
    popupVideo.pause();
    popupVideo.src = '';
    document.body.style.overflow = ''; // reset scroll
  };

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);
});
